import api from '@/api/api.js'

export default {
    async fetchQueues() {
        return await api.clinique().get('/cca-mobile/queues')
    },
    async fetchQueue(id) {
        return await api.clinique().get(`/cca-mobile/queues/${id}`)
    },
    async updateQueue(id) {
        return await api.clinique().put(`/cca-mobile/queues/${id}`)
    },
}